module.exports = __webpack_public_path__ + "media/summer_2025_sweepstakes/submit-a94778a9.svg";